import { render, staticRenderFns } from "./BLayoutAuth.vue?vue&type=template&id=125ae4cb&"
import script from "./BLayoutAuth.vue?vue&type=script&lang=js&"
export * from "./BLayoutAuth.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/transitions/transition-fade.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
